import { employeeRequests } from "api/employeeApi";
import React from "react";
import { FunctionField, ReferenceField } from "react-admin";

const EmployeeField = ({ source, label = "Служител", filters = {} }) => {
  return (
    <ReferenceField
      source={source}
      reference={employeeRequests.getEmployeesSelect()}
      filter={filters}
      emptyText="-"
    >
      <FunctionField
        render={rec =>
          rec.secondName ? `${rec.firstName} ${rec.secondName} ${rec.lastName}` : `${rec.firstName} ${rec.lastName}`
        }
      />
    </ReferenceField>
  );
};

export default EmployeeField;
